var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('embed',{staticClass:"pdfobject",staticStyle:{"overflow":"auto","width":"100%","height":"100%"},attrs:{"src":_vm.mediaResource.viewUrl(),"type":"application/pdf","title":_vm.mediaResource.data().title}})
}
var staticRenderFns = []

export { render, staticRenderFns }